/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Notification: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M15 21H9C9 22.65 10.35 24 12 24C13.65 24 15 22.65 15 21Z' fill='currentColor' />
    <path
      d='M22.5 16.5H21.75C20.7 15.45 19.5 13.95 19.5 12V7.5C19.5 3.3 16.2 0 12 0C7.8 0 4.5 3.3 4.5 7.5V12C4.5 13.95 3.3 15.45 2.25 16.5H1.5C0.6 16.5 0 17.1 0 18C0 18.9 0.6 19.5 1.5 19.5H22.5C23.4 19.5 24 18.9 24 18C24 17.1 23.4 16.5 22.5 16.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
